import { ClientActionTypes } from './constants';

export const setSelectedClientId = (clientId) => ({
    type: ClientActionTypes.SET_CLIENT_ID,
    payload: clientId,
});

export const setSelectedClientName = (clientName) => ({
    type: ClientActionTypes.SET_CLIENT_NAME,
    payload: clientName,
});
